var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83301 8.31618C8.83301 6.69757 8.83301 5.88827 9.17049 5.44215C9.4645 5.0535 9.91388 4.813 10.4003 4.78396C10.9587 4.75062 11.6321 5.19954 12.9789 6.09738L30.5048 17.7813C31.6176 18.5232 32.174 18.8941 32.3679 19.3617C32.5374 19.7704 32.5374 20.2298 32.3679 20.6386C32.174 21.1061 31.6176 21.4771 30.5048 22.2189L12.9789 33.9029C11.6321 34.8007 10.9587 35.2496 10.4003 35.2163C9.91388 35.1873 9.4645 34.9468 9.17049 34.5581C8.83301 34.112 8.83301 33.3027 8.83301 31.6841V8.31618Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.b4c2fb6e4dafa7056362b9114f59e347.svg";
export { ForwardRef as ReactComponent };